module.exports = __webpack_public_path__ + "img/85c4b27.png";